import { render } from "./GeneralModal.vue?vue&type=template&id=0dd5f262&scoped=true"
import script from "./GeneralModal.vue?vue&type=script&lang=js"
export * from "./GeneralModal.vue?vue&type=script&lang=js"

import "@/assets/css/shared/itemModal.css?vue&type=style&index=0&id=0dd5f262&scoped=true&lang=css&external"
import "./GeneralModal.vue?vue&type=style&index=1&id=0dd5f262&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd5f262"],['__file',"src/components/shared/GeneralModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dd5f262"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dd5f262', __exports__)) {
    api.reload('0dd5f262', __exports__)
  }
  
  module.hot.accept("./GeneralModal.vue?vue&type=template&id=0dd5f262&scoped=true", () => {
    api.rerender('0dd5f262', render)
  })

}


export default __exports__